import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useIncomeSummaryModel } from "../incomeSummaryModel";
import { IIncomeSummaryDetail } from "../incomeSummaryService";
import { formatNum, momentFormat } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";

export function SummaryDataTable() {
    const {
        summaryDataSource,
        summaryLoadData
    } = useIncomeSummaryModel();
    const { getTreeNodeName } = useDictModel();

    useEffect(() => {
        summaryLoadData();
    }, [])

    const columns: ColumnsType<IIncomeSummaryDetail> = [
        {
            title: '月份',
            width: 80,
            align: "center",
            dataIndex: 'day',
            render: (t, r, i) => t !== "13" ? t + "月" : "总计",
        }, {
            title: '工时',
            width: 140,
            dataIndex: 'workingHoursAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '配件',
            width: 140,
            dataIndex: 'saleAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '合计',
            width: 140,
            dataIndex: 'totalAmount',
            render: (text) => `￥${formatNum(text)}`
        }
    ];


    return (
        <Table
            bordered
            rowKey={record => record.id}
            columns={columns}
            dataSource={summaryDataSource}
            pagination={false}
            scroll={{ x: 'max-content', y: "calc(100vh - 410px)" }
            }
        />
    )
}